// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d7zmOQbQXgO9wrdz {
    padding: var(--lok-spacing-3) var(--lok-spacing-4);
    max-width: 285px;
    font: var(--lok-typography-body-small-default);

	& a {
		text-decoration: underline;
		color: var(--lok-color-text-light-default);
	}

	& a:hover {
		color: var(--lok-color-text-default);
	}
}`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/EvaluationsButton/EvaluationsButton.module.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;IAClD,gBAAgB;IAChB,8CAA8C;;CAEjD;EACC,0BAA0B;EAC1B,0CAA0C;CAC3C;;CAEA;EACC,oCAAoC;CACrC;AACD","sourcesContent":[".tooltip {\n    padding: var(--lok-spacing-3) var(--lok-spacing-4);\n    max-width: 285px;\n    font: var(--lok-typography-body-small-default);\n\n\t& a {\n\t\ttext-decoration: underline;\n\t\tcolor: var(--lok-color-text-light-default);\n\t}\n\n\t& a:hover {\n\t\tcolor: var(--lok-color-text-default);\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `d7zmOQbQXgO9wrdz`
};
export default ___CSS_LOADER_EXPORT___;
